






import Vue from 'vue';

export default Vue.extend({
  name: "BankMain2d",
  data: () => {
    return {};
  },
});
